RivalIQ.module('views', function (views, App, Backbone, Marionette, $, _) {
    'use strict';

    views.DualGraphHeader = Marionette.ItemView.extend({
        events: {
            'click a': 'onLinkClicked'
        },
        template: '#dualGraphHeaderTemplate',
        onLinkClicked: function (e) {
            const me = this;

            // first things first: stop the normal browser behavior,
            // as we will be taking care of things (like page navigation) ourselves
            e.preventDefault();
            e.stopPropagation();
            me.showDetails();

        },
        showDetails: function () {
            const me = this;
            const model = me.model;
            const link = model.get('link');

            if (link) {
                const click = link.click;

                if (typeof click === 'function') {
                    click(me);
                }

                const href = link.href;

                if (href) {
                    window.location = href;
                }
            }
        }
    });
});
